<template>
  <div class="contents">
    <div class="detail_wrap">
      <h4 class="category">기부후원 단체</h4>
      <div class="tit_wrap">
        <h5 class="tit">{{ donationGroup.groupName }}</h5>
        <div class="sub">{{ donationGroup.groupExplain }}</div>
      </div>
      <div class="cont_wrap">
        <div class="cont">
          <p style="background-color: #e3e3e3; width: 900px; height: 370px; display:none; margin: 0 auto; text-align: center; line-height: 370px; font-size: 18px; font-weight: 600;"></p>
          <p style="text-align: center; font-size: 18px; margin-top: 50px; font-weight: 500; line-height: 1.8;" v-html="donationGroup.editorHtml"></p>
        </div>
      </div>
      <div class="btn_wrap">
        <a @click="toList" class="btn_list">목록</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';


const donationGroupModule = 'donationGroupModule'

export default {
  props: {
    donationGroupSeq: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions(donationGroupModule, [
      'requestDonationGroup'
    ]),

    toList() {
      this.$router.push({ name: 'DonationGroupListPage' })
    }
  },

  computed: {
    ...mapState(donationGroupModule, [
      'donationGroup'
    ])
  },

  async mounted () {
    await this.requestDonationGroup(this.donationGroupSeq)
  }
    
}
</script>
<style lang="">
    
</style>